import type { IconData } from '@stacksjs/iconify-core'

export const databaseServer3: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M3.113 18.555c.142 2.317 2 4.075 4.32 4.172C10.605 22.859 15.889 23 24 23c8.11 0 13.395-.141 16.567-.273c2.32-.097 4.178-1.854 4.32-4.172c.065-1.071.113-2.288.113-3.555s-.048-2.484-.113-3.555c-.142-2.317-2-4.075-4.32-4.172C37.395 7.141 32.111 7 24 7c-8.11 0-13.395.141-16.567.273c-2.32.097-4.178 1.855-4.32 4.172A59 59 0 0 0 3 15c0 1.267.048 2.484.113 3.555M38 15H18m-7 0h-1m14 8v10m-3.992 4h-7m22 0h-7m-8 0a4 4 0 1 0 8 0a4 4 0 1 0-8 0\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default databaseServer3
